module.exports = __webpack_public_path__ + "static/Apercu-Regular-7430433092665c23ee36b3463837644a.woff";